/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceConnector } from "./DeviceConnector";
import {
    DeviceConnectorFromJSON,
    DeviceConnectorFromJSONTyped,
    DeviceConnectorToJSON,
} from "./DeviceConnector";

/**
 *
 * @export
 * @interface ConnectorPricingAssignmentRequest
 */
export interface ConnectorPricingAssignmentRequest {
    /**
     *
     * @type {number}
     * @memberof ConnectorPricingAssignmentRequest
     */
    pricingScheduleGroupId?: number;
    /**
     *
     * @type {Array<DeviceConnector>}
     * @memberof ConnectorPricingAssignmentRequest
     */
    deviceConnectors?: Array<DeviceConnector>;
}

/**
 * Check if a given object implements the ConnectorPricingAssignmentRequest interface.
 */
export function instanceOfConnectorPricingAssignmentRequest(
    value: object,
): value is ConnectorPricingAssignmentRequest {
    return true;
}

export function ConnectorPricingAssignmentRequestFromJSON(
    json: any,
): ConnectorPricingAssignmentRequest {
    return ConnectorPricingAssignmentRequestFromJSONTyped(json, false);
}

export function ConnectorPricingAssignmentRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorPricingAssignmentRequest {
    if (json == null) {
        return json;
    }
    return {
        pricingScheduleGroupId:
            json["pricingScheduleGroupId"] == null
                ? undefined
                : json["pricingScheduleGroupId"],
        deviceConnectors:
            json["deviceConnectors"] == null
                ? undefined
                : (json["deviceConnectors"] as Array<any>).map(
                      DeviceConnectorFromJSON,
                  ),
    };
}

export function ConnectorPricingAssignmentRequestToJSON(
    value?: ConnectorPricingAssignmentRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        pricingScheduleGroupId: value["pricingScheduleGroupId"],
        deviceConnectors:
            value["deviceConnectors"] == null
                ? undefined
                : (value["deviceConnectors"] as Array<any>).map(
                      DeviceConnectorToJSON,
                  ),
    };
}
